import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    leaveWorkList: () => {
        return HTTP.get('/leave', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    changeStatusLeaveWork: (id) => {
        return HTTP.post('/leave/leave_off_on/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addLeaveWork: (data) => {
        return HTTP.post('/leave/create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editLeaveWork: (id,data) => {
        return HTTP.post('/leave/update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailLeaveWork: (id) => {
        return HTTP.get('/leave/edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deleteLeaveWork: (id) => {
        return HTTP.post('/leave/destroy/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    
}